import { Element } from "@js/extends";

export default class Tabs extends Element {
	mounted() {
		this.tabButtons = this.el.querySelectorAll(".js-tabs-trigger");
		this.tabPanels = this.el.querySelectorAll(".js-tabs-target");
		this.hiddenClass = "is-hidden";
		this.activeIndex = 0;
	}

	events() {
		this.tabButtons.forEach((tab, index) => {
			tab.addEventListener("click", (e) => this.click(e, index));
		});
	}

	click(e, index) {
		e.preventDefault();
		this.switchTab(index);
	}

	switchTab(index) {
		if (index === this.activeIndex) return;

		this.setTabState(this.activeIndex, false);
		this.setTabState(index, true);

		this.activeIndex = index;
	}

	setTabState(index, isActive) {
		const button = this.tabButtons[index];
		const panel = this.tabPanels[index];

		button.classList.toggle("a-filter--active", isActive);
		button.ariaSelected = isActive;
		panel.classList.toggle(this.hiddenClass, !isActive);
		panel.ariaHidden = !isActive;
	}
}
